<template>
    <b-form>
        <loader v-if="isLoading" />
        <div v-if="!isLoading">
            <b-form-checkbox
                v-model="selectAllItems"
                class="checkbox-margin-top"
                plain
                @change="changeSelectAll"
                label-style
                ><b style="padding-top: 2px;"
                    >Select / Unselect All</b
                ></b-form-checkbox
            >

            <hr class="mb-0" />

            <b-alert :show="isShowAlert" variant="warning">
                <i class="cus-error"></i>
                'Due' date has to be later than 'Given' date
            </b-alert>
            <b-row class="w-100 pt-3">
                <b-col cols="6" class="text-left align-item">Item:</b-col>
                <b-col cols="3" class="text-left">Given:</b-col>
                <b-col cols="3" class="text-left">Due:</b-col>
            </b-row>

            <reminder-item-row
                v-for="item in data.itemOptions"
                :key="item.id"
                :item="item"
                @selected-changed="checkEachItem"
                @trigger-show-alert="triggerShowAlert"
            />
        </div>
    </b-form>
</template>

<script type="text/javascript">
import { forEach, map, uniqBy, cloneDeep, pull, filter } from "lodash";
import ReminderItemRow from "@/components/reminder-bundle/reminder-item-row";

export default {
    components: {
        ReminderItemRow,
        Loader: () => import("@/components/elements/loader")
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            selectAllItems: true,
            isShowAlert: false,
            itemsErrorDue: []
        };
    },
    computed: {},
    watch: {},
    mounted() {
        let self = this;
        if (self.data.bundleId.length > 0) {
            self.getCiBundle();
        }
    },
    methods: {
        changeSelectAll(value) {
            for (let item of this.data.itemOptions) {
                item.selected = value;
            }
            this.checkEachItem();
        },
        checkEachItem() {
            let self = this;
            let iscontinue = true;
            let selectedItems = filter(self.data.itemOptions, {
                selected: true
            });

            self.data.items = cloneDeep(selectedItems);

            map(selectedItems, item => {
                if (!item.has_reminder_action) {
                    iscontinue = false;
                }
            });

            self.$emit("update-iscontinuesave", iscontinue);

            if (self.data.items.length == self.data.itemOptions.length) {
                self.selectAllItems = true;
            } else {
                self.selectAllItems = false;
            }
        },
        getCiBundle() {
            let self = this;
            self.isLoading = true;
            self.$emit("loading");

            var bundleIds = "";

            // check if bundle id is array or not
            // if array, its multiple bundles
            // if not array, its single bundle
            if (Array.isArray(self.data.bundleId)) {
                forEach(self.data.bundleId, function (value, key) {
                    bundleIds += "id[]=" + value.id + "&";
                });
            } else {
                bundleIds += "id[]=" + self.data.bundleId + "&";
            }

            self.$http
                .get(
                    process.env.APPS +
                        "ajax/bundle/find_items?" +
                        bundleIds +
                        "module=reminder"
                )
                .then(response => {
                    if (response.data.length > 0) {
                        if (
                            self.data.itemOptions.length == 0 &&
                            self.data.itemOptions.length != response.data.length
                        ) {
                            self.data.itemOptions = map(
                                response.data,
                                function (item) {
                                    let dueDate = null;
                                    let dueDuration = null;
                                    if (item.due != "") {
                                        let due = item.due.split(" "); // based on api, return x {period} ex: 1 month, 2 weeks
                                        // for luxon plus(period: duration) ex plus(months: 1)
                                        dueDuration = {};
                                        dueDuration[due[1]] = due[0];

                                        if (due.length == 2) {
                                            dueDate = self
                                                ._now()
                                                .plus(dueDuration)
                                                .toFormat(
                                                    self._getLuxonFormat()
                                                );
                                        }
                                    }

                                    return {
                                        ...item,
                                        ...{
                                            selected: true,
                                            givenDate: null,
                                            dueDate: dueDate,
                                            dueDuration: dueDuration
                                        }
                                    };
                                }
                            );
                            self.data.itemOptions = uniqBy(
                                self.data.itemOptions,
                                "item_id"
                            );
                        }
                        // this.data.items = cloneDeep(this.data.itemOptions);
                        this.checkEachItem();
                        this.loaded = true;
                    } else {
                        this.loaded = false;
                    }
                })
                .finally(() => {
                    self.isLoading = false;
                    this.$emit("loaded", this.loaded);
                });
        },
        triggerShowAlert({ item, action }) {
            if (!this.itemsErrorDue.includes(item) && action == "add") {
                this.itemsErrorDue.push(item);
            } else if (action == "remove") {
                pull(this.itemsErrorDue, item);
            }
            this.isShowAlert = this.itemsErrorDue.length > 0;
        }
    }
};
</script>
<style scoped>
.align-item {
    padding-left: 2.2rem;
}
</style>
